import withHelmet from '../HOC/withHelmet';
import AboutPage from '../components/about';

export default withHelmet(AboutPage, 'About us');
